import React, { useState } from 'react';
import type { ComponentType } from '@ext-bookmark/shared/types';
import { addComponent } from '../lib/storage';
import ComponentSelector from './ComponentSelector';

interface AddComponentButtonProps {
  parentId?: string;
  parentType?: ComponentType;
  workspaceId: string;
  onComponentAdded: () => void;
  className?: string;
  variant?: 'button' | 'icon';
}

const AddComponentButton: React.FC<AddComponentButtonProps> = ({
  parentId,
  parentType,
  workspaceId,
  onComponentAdded,
  className = '',
  variant = 'button',
}) => {
  const [showSelector, setShowSelector] = useState(false);

  const handleSelectComponent = async (componentType: ComponentType) => {
    try {
      const newComponent = await addComponent(workspaceId, {
        componentType,
        name: `分区 ${Date.now()}`,
        parentId,
        config: {},
      });

      if (newComponent) {
        setShowSelector(false);
        onComponentAdded();
      }
    } catch (error) {
      console.error('Failed to add component:', error);
      alert('添加组件失败，请重试');
    }
  };

  if (variant === 'icon') {
    return (
      <>
        <button
          onClick={() => setShowSelector(true)}
          className={`p-2 rounded-lg hover:bg-gray-100 dark:hover:bg-gray-700 transition-colors ${className}`}
          title="添加组件"
        >
          <svg className="w-5 h-5 text-gray-600 dark:text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 4v16m8-8H4" />
          </svg>
        </button>
        {showSelector && (
          <ComponentSelector
            parentId={parentId}
            parentType={parentType}
            onSelect={handleSelectComponent}
            onCancel={() => setShowSelector(false)}
          />
        )}
      </>
    );
  }

  return (
    <>
      <button
        onClick={() => setShowSelector(true)}
        className={`px-4 py-2 bg-blue-600 hover:bg-blue-700 text-white rounded-lg text-sm font-medium transition-colors flex items-center gap-2 ${className}`}
      >
        <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 4v16m8-8H4" />
        </svg>
        添加组件
      </button>
      {showSelector && (
        <ComponentSelector
          parentId={parentId}
          parentType={parentType}
          onSelect={handleSelectComponent}
          onCancel={() => setShowSelector(false)}
        />
      )}
    </>
  );
};

export default AddComponentButton;
